import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  description: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4)
  },
  confirmBtn: {
    marginTop: theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  },
  actionBtnContainer: {
    marginTop: theme.spacing(3),
    flex: 1,
    justifyContent: 'flex-start'
  },
  actionBtn: {
    marginRight: theme.spacing(2),
    color: theme.palette.secondary.main
  },
  driverCardContainer: {
    marginBottom: theme.spacing(2)
  }
});

export default makeStyles(styles);
